import { render } from "./BaseLayout2.vue?vue&type=template&id=0d7fb68b&scoped=true"
import script from "./BaseLayout2.vue?vue&type=script&lang=js"
export * from "./BaseLayout2.vue?vue&type=script&lang=js"

import "./BaseLayout2.vue?vue&type=style&index=0&id=0d7fb68b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d7fb68b"

export default script